import React from 'react'
import Navbar from '../inc/Navbar'
import {Link} from "react-router-dom";
import Logo from "../images/logo chuapur ict.png";
import "./Home.css";
import Slider from '../inc/Slider';
import Aboutus from './Aboutus';
import ScrollToTop from "react-scroll-to-top";
import GoverningBody from './GoverningBody';
import paymentqr from "../images/payment.jpeg";


function Home() {
  return (
    <div>
      <Navbar/>
      <br/>
      <br/>
      <br/>
      <br/>

    
        <div className="chuapurict">
                <div className="album py-2">
                    <div className="container">
                        <div className="row ">
                            <div className="col-md-2">
                                <center>
                                    <Link to="/">
                                        <img src={Logo} className='mt-3 logokps' width="165px" height="100px" alt="kps logo" />

                                    </Link>

                                </center>
                            </div>
                            <div className="col-md-8">
                                <center>

                                    <h1 style={{ color: "#089205" }} className='font mb-0 mt-3'><b>CHUAPUKUR ISLAMIC CHARITABLE TRUST</b></h1>
                                    <div className='fonts'>
                                        <p style={{ color: "#0049A9" }} className='mb-2'>Regd. No. IV-1205-00043/2020 </p>

                                        <h6 style={{ color: "#0049A9" }} className='mb-0' >Regd. No. IV-1205-00043/2020 | ESTD: 2018</h6>

                                    </div>

                                </center>
                            </div>


                            <div className="d-flex justify-content-between align-items-center">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Slider/>
            <Aboutus/>
            <br/>
            <div className='islamictrust'>
            <GoverningBody/>
            </div>
            <br/>
                        <ScrollToTop smooth top="100" color="maroon" />


  <div className="album py-0">
                <div className="container">
                    <div className="row">





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad89'>BANK DETAILS <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-bank" viewBox="0 0 16 16">
  <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z"/>
</svg> </h4>

                                    <div className="card-body ">

                                        <div className='welcometext'>
                                            <br />
                                            
<h6 style={{color:"#107b0c"}}><b>BANK DETAILS: A/C No: 50200115596417 
    <br/>IFSC: HDFC0008658; HDFC Bank, Lalgola Branch: MSD: WB</b></h6>
                                        <img src={paymentqr}  height="380px" width="280px" alt="paymentqr"/>

                                            <br />
                                            <br />
                                           

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad90'>CHUAPUKUR ICT DETAILS <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
</svg></h4>
                                    <div className="card-body">
                                        <div className='welcometext'>

                                            <br />
                                          
<h6 style={{color:"#107b0c"}}><b>Regd. No. IV-1205-00043/2020: PAN OF TRUST: AACTC7780M
80G-AACTC7780MF20241:12A-AACTC7780MF20241
E-Filing No. 601937280141024: Income Tax Department
Govt. of India. N.I.for T.India: Certificate of Enrollment:
Unique ID: WB/2024/0457764</b></h6>


                                            <br />
                                       




                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />
              <div className="album py-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mt-3">

<iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F778237921937097%2F&show_text=false&width=267&t=0" width="100%" height="500"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
                            </div>


                            <div className="col-md-6 mt-3">
<iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1359138738346180%2F&show_text=true&width=267&t=0" width="100%" height="500" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>                            </div>
                        </div>
                    </div>
                </div>
    </div>

  )
}

export default Home